import { FC, useEffect } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { AiImageGenerationModal } from 'components/common/BannerImg/AiImageGenerationModal/AiImageGenerationModal';
import { BannerImg } from 'components/common/BannerImg/BannerImg';
import { CropImageModal } from 'components/common/BannerImg/CropImageModal/CropImageModal';
import { GalleryModal } from 'components/common/BannerImg/GalleryModal/GalleryModal';
import { BannerVideo } from 'components/common/BannerVideo/BannerVideo';
import { BannerLink } from 'components/CpcFlexibleCreate/CpcForm/BannerLink/BannerLink';
import { BannerText } from 'components/CpcFlexibleCreate/CpcForm/BannerText/BannerText';
import { BannerTitle } from 'components/CpcFlexibleCreate/CpcForm/BannerTitle/BannerTitle';
import { ErirClassification } from 'components/CpcFlexibleCreate/CpcForm/ErirClassification/ErirClassification';
import { fetchBannerByVacancy } from 'components/CpcFlexibleCreate/CpcForm/Vacancies/fetchBannerByVacancy';
import { Vacancies } from 'components/CpcFlexibleCreate/CpcForm/Vacancies/Vacancies';

import { useDispatch, useSelector } from 'store/utils';

export const isBannerByVacancy = (vacancyId: number): boolean => vacancyId > 0;

export const BannerForm: FC = () => {
    const { bannerVacancyId, bannerId } = useSelector((state) => state.createBanner);

    const dispatch = useDispatch();

    useEffect(() => {
        if (bannerVacancyId && isBannerByVacancy(bannerVacancyId) && bannerId === 0) {
            dispatch(fetchBannerByVacancy(bannerVacancyId, false));
        }
    }, [bannerId, dispatch, bannerVacancyId]);

    return (
        <>
            {bannerVacancyId && isBannerByVacancy(bannerVacancyId) && <Vacancies />}
            <BannerLink />
            <ErirClassification />
            <BannerTitle />
            <BannerText />
            <BannerImg />
            <BannerVideo />
            <VSpacing default={32} />
            <CropImageModal />
            <GalleryModal />
            <AiImageGenerationModal />
        </>
    );
};
